import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<div class=\"c-move-to-web3\">\n  {{yield}}\n</div>",{ moduleName: "mewe/pods/components/cms/routable/move-to-web3/template.hbs" })